export default __webpack_public_path__ + "static/media/header.3de8cd13.png";